module.exports = __webpack_public_path__ + "media/src/shared_components/images/chevron_left-6f240ca04ff47a22e26bf409facd3dbb.svg";